<div class="no-record-wrapper flex flex-col justify-center items-center pb-3">
  <img src="../../../../../assets/images/icons/plagiarism.svg"
       alt="No records"
       class="w-12">
  <p class=" !text-base text-lightGray !mb-0">{{notFoundMessage}}</p>
</div>
